// extracted by mini-css-extract-plugin
export default {"btn":"BookmarkButton_btn__mvFHv"};